export default {
  branding: {
    'logo-black': '/assets/new/branding/logo-black@4x.png',
    'logo-black-foreign': '/assets/new/branding/logo-black-foreign.png',
  },
  auth: {
    'login-truck': '/assets/new/auth/login-truck.png',
    'login-bg': '/assets/new/auth/login-bg.png',
  },
  barcode: {
    'barcode-mini-icon': '/assets/new/barcode/barcode-mini-icon.png',
    'barcode-info-zoom': '/assets/new/barcode/barcode-info-zoom.png',
  },
  favRoutes: {
    modalTopBg: '/assets/new/fav-routes/fav-route-modal-bg.png',
  },
  bidding: {
    'annoucement-modal-bg': '/assets/new/bidding/bidding-annoucement-modal-bg.png',
    'annoucement-modal-icon': '/assets/new/bidding/bidding-annoucement-modal-icon.png',
  },
}
